import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@components/icons';
import { socialMedia } from '@config';

const StyledFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  min-height: 60px;
  padding: 20px 50px;
  background: var(--surface-color);
  border-top: 1px solid var(--text-dark);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
    gap: 15px;
    text-align: center;
  }
`;

const StyledSocialLinks = styled.div`
  display: block;
  width: 100%;
  max-width: 300px;
  margin: 0 auto 20px;
  color: var(--text-main);

  ul {
    ${({ theme }) => theme.mixins.flexBetween};
    padding: 0;
    margin: 0;
    list-style: none;

    a {
      padding: 10px;
      transition: var(--transition);
      
      svg {
        width: 24px;
        height: 24px;
      }

      &:hover {
        color: var(--accent-main);
        transform: translateY(-3px);
      }
    }
  }
`;

const StyledCredit = styled.div`
  color: var(--text-muted);
  font-family: var(--font-mono);
  font-size: var(--fz-xs);
  line-height: 1.5;

  a {
    padding: 10px;
    transition: var(--transition);
    
    &:hover {
      color: var(--accent-main);
    }
  }

  .github-stats {
    margin-top: 10px;

    & > span {
      display: inline-flex;
      align-items: center;
      margin: 0 7px;
    }
    svg {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
    }
  }
`;

const Footer = () => {
  const [githubInfo, setGitHubInfo] = useState({
    stars: null,
    forks: null,
  });

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }
    fetch('https://api.github.com/repos/keerthankacharya/portfolio')
      .then(response => response.json())
      .then(json => {
        const { stargazers_count, forks_count } = json;
        setGitHubInfo({
          stars: stargazers_count,
          forks: forks_count,
        });
      })
      .catch(e => console.error(e));
  }, []);

  return (
    <StyledFooter>
      <StyledCredit tabIndex="-1">
        <div>Human-crafted. AI-accelerated.</div>
      </StyledCredit>
      <StyledCredit tabIndex="-1">
        <div>
          <span style={{ fontFamily: 'sans-serif', fontSize: '1.3em', verticalAlign: 'middle', display: 'inline-block', transform: 'translateY(-1px)' }}>&copy;</span> Keerthan K Acharya {new Date().getFullYear()} | All Rights Reserved
        </div>
      </StyledCredit>
    </StyledFooter>
  );
};

Footer.propTypes = {
  githubInfo: PropTypes.object,
};

export default Footer;
